/* eslint-disable no-unused-vars */
import React, { FC, memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Radio, RadioGroup, FormControlLabel, Box } from '@material-ui/core';
import useCustomerPayment from 'src/hooks/customer-payment/use-customer-payment';
import { CommonCustomerPaymentPayload } from 'src/redux/slices/customer-payment';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    gap: '52px',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '16px'
    }
  },
  labelTop: {
    margin: 0,
    display: 'flex',
    alignItems: 'center'
  }
}));

interface Props {}

const Component: FC<Props> = () => {
  const classes = useStyles();
  const { customerPaymentParams, setParams } = useCustomerPayment();

  const handleChange = (value: string) => {
    //toggle radio options to set and unset option
    if (customerPaymentParams?.sub_payment_type === value) {
      setParams({
        ...customerPaymentParams,
        sub_payment_type: undefined
      });
    } else {
      setParams({
        ...customerPaymentParams,
        sub_payment_type: value
      });
    }
  };

  return (
    <RadioGroup
      style={{ justifyContent: 'center', alignItems: 'center' }}
      value={customerPaymentParams?.sub_payment_type || ''}
    >
      <Box className={classes.container}>
        <FormControlLabel
          className={classes.labelTop}
          value="credit_cards"
          control={<Radio color="primary" />}
          label="Credit Cards"
          labelPlacement="end"
          onClick={() => handleChange('credit_cards')}
        />

        <FormControlLabel
          className={classes.labelTop}
          value="paymongo_online"
          control={<Radio color="primary" />}
          label="PayMongo Online"
          labelPlacement="end"
          onClick={() => handleChange('paymongo_online')}
        />

        <FormControlLabel
          className={classes.labelTop}
          value="paymongo"
          control={<Radio color="primary" />}
          label="PayMongo"
          labelPlacement="end"
          onClick={() => handleChange('paymongo')}
        />
      </Box>
    </RadioGroup>
  );
};

export const PaymentMode = memo(Component);
